<template>
  <div class="app-menu" :class="className">
    <div class="w-1200 clearfix">
      <div class="foslink-logo fl">
        <div class="foslink-top">
          <img :src="logo" alt="">
          <span>中消云</span>
        </div>
        <div class="foslink-subTitle">
          <p>赋能企业数字化转型</p>
          <p>数字化构建企业安全</p>
        </div>
        <!-- <p> — 工业互联网+安全生产引领者 —</p> -->
      </div>
      <!-- pc -->
      <div class="fr" v-if="IsPC()">
        <ul class="foslink-menu">
          <li :class="{'is-active':activeName==item.name}" @click.stop="goPage(item)" @mouseover="goOverOrLeave(item, 1)" @mouseleave="goOverOrLeave(item,2)" v-for="(item, index) in menuList" :key="index">
            <i v-if="item.isHot" class="hot-title"></i><span class="menu-title">{{item.title}}</span>
             <!-- <el-collapse-transition> -->
            <transition name="el-fade-in-linear">
              <!-- <menu-device v-show="showDeviceMenu" v-if="item.name=='device'"/> -->
              <menu-product v-show="showProMenu" v-if="item.name=='product'"/>
              <!-- <menu-case v-show="showCaseMenu" v-if="item.name=='case'"/> -->
            </transition>
             <!-- </el-collapse-transition> -->
          </li>
        </ul>
        <!--  -->
      </div>
      <!-- 移动端 -->
      <div class="fr" v-else>
        <span class="el-icon-menu" @click="openMenu" :class="showAppMenu?'show-menu':''"></span>
        <el-collapse-transition>
          <ul class="phone-menu" v-show="showAppMenu">
            <li v-for="(item, index) in menuList" :key="index">
              <div @click.stop="goAppPage(item)"><i v-if="item.isHot" class="hot-title"></i> {{item.title}} <i  v-if="item.isChildren" :class="isShowInfo(item)?'el-icon-arrow-up':'el-icon-arrow-down'"></i> </div>
              <!-- <transition name="el-fade-in-linear"> -->
              <el-collapse-transition>
                <!-- <menu-device v-show="showDeviceMenu" v-if="item.name=='device'" @closeMenu="closeMenu"/> -->
                <menu-product v-show="showProMenu" v-if="item.name=='product'" @closeMenu="closeMenu"/>
                <!-- <menu-case v-show="showCaseMenu" v-if="item.name=='case'" @closeMenu="closeMenu"/> -->
              </el-collapse-transition>
              <!-- </transition> -->
            </li>
            <li @click="goFreeBtn">免费试用</li>
          </ul>
        </el-collapse-transition>
      </div>
      <div class="app-mf-btn" v-if="IsPC()">
        <div class="menu-btn-mf" @click="goFreeBtn">免费试用</div>
      </div>
    </div>
    
    <!-- 免费试用 -->
    <free-dialog ref="free"/>
  </div>
</template>

<script>
import freeDialog from "./freeDialog"
import menuDevice from "./menu-device"
import menuProduct from "./menu-product"
import menuCase from "./menu-case"
import { menuList } from "./common"
import { IsPC } from "@/utils"

const logo = '/images/foslink-logo.png'
export default {
  components: {freeDialog,menuDevice, menuProduct,menuCase},
  props: ['className'],
  data (){
    return{
      logo,
      menuList,
      activeName: '',
      showDeviceMenu: false,
      showProMenu: false,
      showCaseMenu: false,
      showAppMenu: false
    }
  },
  watch: {
    $route: {
      handler(n, o){
        this.initPage()
      },
      deep: true
    },
    showAppMenu(n, o){
      this.showDeviceMenu = false
      this.showCaseMenu = false
      this.showProMenu = false
      if(n){
        // $('#app').css('position','fixed')
      } else{
        // $('#app').css('position','relative')
      }
    }
  },
  created (){
    this.initPage()
  },
  methods: {
    IsPC,
    openMenu (){
      this.showAppMenu = !this.showAppMenu
    },
    initPage(){
      let routeName = this.$route.name
      if(routeName === 'productDetails' || routeName === 'prdTrain' || routeName === 'bigDanger') {
        this.activeName = 'product'
      } else if(routeName === 'caseDetails') {
        this.activeName = 'case'
      } else if(routeName === 'deviceInfo') {
        this.activeName = 'device'
      } else if(routeName === 'apply') {
        this.activeName = 'maintenance'
      } else {
        this.activeName = this.$route.name
      }
    },
    closeMenu(type){
      this.showAppMenu = false
      if(type == 1){
        this.showProMenu = false
      } else if(type == 2){
        this.showCaseMenu = false
      } else if(type == 3){
        this.showDeviceMenu = false
      }
    },
    goPage (item){
      this.$router.push({path: item.path})
    },
    goOverOrLeave (item, type){
      if(item.name === 'device'){
        this.showDeviceMenu = type === 1
      } else if(item.name == 'product'){
        this.showProMenu = type === 1
      }
      // else if (item.name == 'case') {
      //   this.showCaseMenu = type === 1
      // }
    },
    goAppPage (item){
      if(item.name === 'device'){
        this.showDeviceMenu = !this.showDeviceMenu
      } else if(item.name == 'product'){
        this.showProMenu = !this.showProMenu
      }
      // else if (item.name == 'case') {
      //   this.showCaseMenu = !this.showCaseMenu
      // }
      else {
        this.$router.push({path: item.path})
      }
    },
    isShowInfo (item){
      if(item.name === 'device'){
        return this.showDeviceMenu
      } else if(item.name == 'product'){
        return this.showProMenu
      }
      // else if (item.name == 'case') {
      //   return this.showCaseMenu
      // }
    },
    goFreeBtn () {
      this.$refs.free.handleOpen()
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/menu.scss';
</style>


// WEBPACK FOOTER //
// src/views/components/AppMenu.vue